import styled from 'styled-components';

interface FilterSubItemContainerProps {
  maxHeight?: string | number;
  hideMaxHeight?: boolean;
  noEndGradient?: boolean;
  noPaddingBottom?: boolean;
  noOverflowY?: boolean;
}

const FilterSubItemContainer = styled.div<FilterSubItemContainerProps>`
  position: relative;
  width: 100%;

  & > ul {
    ${({ maxHeight, hideMaxHeight = false }) =>
      !hideMaxHeight && `max-height: ${maxHeight || '42vh'};`}
    min-height: ${({ theme }) => theme.spacing[160]};
    overflow-y: auto;
    overflow-x: hidden;
    margin-right: ${({ theme }) => theme.spacing[8]};
    ${({ theme, noPaddingBottom }) =>
      noPaddingBottom
        ? 'padding-bottom: 0;'
        : `padding-bottom: ${theme.spacing[24]};`}

    &.sub-items--no-overflow {
      overflow: hidden;
    }
  }

  ${({ theme, noEndGradient = false }) =>
    !noEndGradient &&
    `
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 90%;
      height: 40px;
      background: linear-gradient(
        0deg,
        ${theme.colors.white} 0%,
        rgba(255, 255, 255, 0) 106.25%
      );
      pointer-events: none;
    }
  `}
`;

export default FilterSubItemContainer;
